export default __webpack_public_path__ + "static/media/arrow_down.4d00fa04.svg";